import wproofreaderIcon from '../theme/icons/wproofreader.svg';

export { default as WProofreader } from './wproofreader.js';

export const icons = {
	wproofreaderIcon
};
